import AuthChangeLicenceIdButton from '@/components/Auth/AuthChangeLicenceIdButton'
import AuthCurrentLicenceCard from '@/components/Auth/AuthCurrentLicenceCard'
import AuthHeaderKeyboardAvoidingView from '@/components/Auth/AuthHeaderKeyboardAvoidingView'
import AuthDeviceCodeField from '@/components/Auth/Device/AuthDeviceCodeField'
import TitleWithHint from '@/features/auth/components/TitleWithHint'
import { useAppDispatch, useAppSelector } from '@/hooks/redux'
import { clearAuthLicenceNameAndDeviceId } from '@/redux/reducers/auth'
import { authSelectors } from '@/redux/reducers/auth/selectors'
import { useFocusEffect } from '@react-navigation/native'
import { Redirect } from 'expo-router'
import { FC, useCallback, useRef } from 'react'
import { useTranslation } from 'react-i18next'

const authRequestExpirationTime = 10 * 60 * 1000

const AuthDeviceScreen: FC = () => {
    const deviceId = useAppSelector(authSelectors.deviceId)
    const licenceName = useAppSelector(authSelectors.licenceName)
    const licenceId = useAppSelector(authSelectors.licenceId)

    const dispatch = useAppDispatch()

    const { t } = useTranslation()

    const timerRef = useRef<number | null>(null)

    useFocusEffect(
        useCallback(() => {
            timerRef.current = setTimeout(() => {
                dispatch(clearAuthLicenceNameAndDeviceId())
            }, authRequestExpirationTime)

            return () => {
                if (!timerRef.current) return

                clearTimeout(timerRef.current)

                timerRef.current = null
            }
        }, [dispatch])
    )

    if (!deviceId || !licenceName || !licenceId) {
        return <Redirect href="/auth" />
    }

    return (
        <AuthHeaderKeyboardAvoidingView>
            <TitleWithHint
                title={t('authScreensDeviceAuthorization')}
                hint={t('deviceAuthorizationScreenEnterCode') + '\n' + deviceId}
            />
            <AuthCurrentLicenceCard name={licenceName} id={licenceId} />
            <AuthChangeLicenceIdButton />
            <AuthDeviceCodeField />
        </AuthHeaderKeyboardAvoidingView>
    )
}

export default AuthDeviceScreen
